/* import Vue from 'vue'
import _ from 'lodash' */
import { getLoggedUserCookie, urlBase64ToUint8Array } from "../../tools/auth";

/*************************************
 State
 **/
const state = {
	registration: null,
	currentSubscription: null,
	resaToLoad: null,
};

/*************************************
 Getters
 **/
const getters = {
	/**
	 * get registration
	 * @param {*} state
	 */
	getRegistration: function (state) {
		return state.registration;
	},
	getResaToLoad: function (state) {
		return state.resaToLoad;
	},
};

/*************************************
 Mutations
 **/
const mutations = {
	setRegistration(state, datas) {
		state.registration = datas;
	},
	setCurrentSubscription(state, datas) {
		state.currentSubscription = datas;
	},
	setResaToLoad(state, datas) {
		state.resaToLoad = datas;
	},
};

/*************************************
 Action
 **/
const actions = {
	/**
	 * Create Socket
	 * @param {*} store params
	 */
	async initServiceWorker({ state, rootState, commit, dispatch }) {
		var isLocalhost = Boolean(
			window.location.hostname === "localhost" ||
				// [::1] is the IPv6 localhost address.
				window.location.hostname === "[::1]" ||
				// 127.0.0.1/8 is considered localhost for IPv4.
				window.location.hostname.match(
					/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
				),
		);

		if (
			"serviceWorker" in navigator &&
			window.location.protocol === "https:" &&
			!isLocalhost
		) {
			// check if serviceworker exist
			if (navigator.serviceWorker.controller) {
				var url = navigator.serviceWorker.controller.scriptURL;
				console.log("serviceWorker already exist ", url);
			} else {
				// If not register the ServiceWorker
				navigator.serviceWorker
					.register("service-worker.js", {
						scope: "./",
					})
					.then((registration) => {
						window.location.reload();
					})
					.catch((err) => {
						console.error("serviceworker ERROR : ", err);
					});
			}
			// save wervice worker registration
			await navigator.serviceWorker.ready.then((registration) => {
				commit("setRegistration", registration);
			});
		}
	},

	async checkNotificationAuth({ state, rootState, commit, dispatch }) {
		if (Notification.permission !== "granted") {
			Notification.requestPermission().then((result) => {
				if (result === "granted") {
					if (navigator.serviceWorker.controller) {
						dispatch("pushManagerRegistration");
					}
				}
			});
		} else {
			dispatch("pushManagerRegistration");
		}
	},

	serviceWorkerMessageListener: function ({
		state,
		rootState,
		commit,
		dispatch,
		getters,
		rootGetters,
	}) {
		navigator.serviceWorker.removeEventListener("message", (evt) => {
			let resa = evt.data.data;
			commit("setResaToLoad", resa);
			if (rootGetters["getLoadingState"]) {
				dispatch("loadResaToLoad");
			}
		});
		navigator.serviceWorker.addEventListener("message", (evt) => {
			let resa = evt.data.data;
			commit("setResaToLoad", resa);
			if (rootGetters["getLoadingState"]) {
				dispatch("loadResaToLoad");
			}
		});
	},

	loadResaToLoad: function ({
		state,
		rootState,
		commit,
		dispatch,
		getters,
		rootGetters,
	}) {
		// wait app open and init
		setTimeout(() => {
			commit("calendar/setSelectedDay", state.resaToLoad.dateResa, {
				root: true,
			});
			commit(
				"newServices/setSelectedService",
				{ ms: state.resaToLoad.ms, subs: state.resaToLoad.subs },
				{ root: true },
			);
			dispatch("newReservations/syncRTCurrentResas", {}, { root: true }).then(
				() => {
					let resaSelected = rootGetters["newReservations/getCurrentResaById"](
						state.resaToLoad.id,
					);
					commit("newReservations/setSelectedResa", resaSelected, {
						root: true,
					});
					commit("newRooms/setModLinkTable", true, { root: true });

					dispatch("displayer/showHidePopupManageServices", {}, { root: true });
					dispatch("calendar/showVisibilityCalendar", false, { root: true });
					// clear resa to load
					commit("setResaToLoad", null);
					// clear badges
					dispatch("cleanNotifications");
				},
			);
		}, 500);
	},

	cleanNotifications: function ({
		state,
		rootState,
		commit,
		dispatch,
		getters,
		rootGetters,
	}) {
		navigator.setAppBadge(0);
		state.registration.getNotifications().then((notifications) => {
			notifications.forEach((notification) => notification.close());
		});
	},

	/**
	 * push notification Manager Registration
	 * @param {*} store params
	 */
	pushManagerRegistration: function ({
		state,
		rootState,
		commit,
		dispatch,
		getters,
		rootGetters,
	}) {
		state.registration.pushManager
			.getSubscription()
			.then(async (subscription) => {
				// registration part
				// get if app is registered
				if (subscription) {
					return subscription;
				}
				// if not create new registration
				const response = await fetch(
					`${import.meta.env.VITE_BACK_URL}/webpush/getvapidKey`,
				);
				const vapidPublicKey = await response.text();
				const convertedVapidKey = urlBase64ToUint8Array(
					vapidPublicKey.replaceAll('"', ""),
				);

				return state.registration.pushManager.subscribe({
					userVisibleOnly: true,
					applicationServerKey: convertedVapidKey,
				});
			})
			.then((subscription) => {
				getLoggedUserCookie().then((cookie) => {
					const data = {
						restoid: cookie.user.restoid,
						subscription: subscription,
					};

					commit("setCurrentSubscription", subscription);
					// subscription part
					// send the subscription to the server
					fetch(`${import.meta.env.VITE_BACK_URL}/webpush/register`, {
						method: "post",
						headers: {
							"Content-type": "application/json",
						},
						body: JSON.stringify({ data }),
					});
				});
			})
			.catch(function (e) {
				console.error("Error during service worker registration:", e);
			});
	},

	removeCurrentSubscription: function (
		{ state, rootState, commit, dispatch, getters, rootGetters },
		restoid,
	) {
		return new Promise((resolve, reject) => {
			if (state.currentSubscription) {
				const data = {
					restoid: restoid,
					subscription: state.currentSubscription,
				};

				fetch(`${import.meta.env.VITE_BACK_URL}/webpush/remove`, {
					method: "post",
					headers: {
						"Content-type": "application/json",
					},
					body: JSON.stringify({ data }),
				}).then((el) => {
					resolve();
				});
			} else {
				resolve();
			}
		});
	},
};

/*************************************
 Export module
 **/
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
